module.exports = __webpack_public_path__ + "static/media/fith.a0d34b68.gif";